import { NgModule, InjectionToken, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Authenticator } from './services/authenticator';
import { DacConfig } from './services/dac-config.service';
import {AssessmentHydrator} from "./services/assessment-hydrator.service";
import {AssessmentResultHydrator} from "./services/assessment-result-hydrator.service";
import {UniqueIdService} from "./services/unique-id.service";
import { PaginatedResultsLoaderFactory } from "./services/pagination-results-loader-factory.service";
import { HTTPService } from "./services/http.service";
import { AssessmentService } from "./services/assessment.service";
import { ClientService } from "./services/client.service";
import { AssessmentPickerComponent } from './assessment-picker/assessment-picker.component';
import { StripePaymentProcessor } from "./services/stripe-payment-processor.service";
import { AssessmentTokenService } from "./services/assessment-token.service";
import { SpinIconComponent } from './spin-icon/spin-icon.component';
import { AssessmentCompressorService } from "./services/assessment-compressor.service";
import { IfFeatureEnabled } from "./feature-enabled/feature-enabled";
import { ConditionEditComponent } from './condition-edit/condition-edit.component';
import { QuestionFactoryService } from './services/question-factory.service';
import { AssessmentGraderService } from './services/assessment-grader.service';
import { QuestionAnswerPopulator } from "./services/question-answer-populator.service";
import { SearchInputComponent } from './search-input/search-input.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { UserService } from "./services/user.service";
import { CompanyService } from './services/company.service';
import { AlertService } from './services/alert.service';
import { UserSelectorComponent } from './user-selector/user-selector.component';
import { UsernameCheckerComponent } from './username-checker/username-checker.component';
import { RoleSelectorComponent } from './role-selector/role-selector.component';
import { Pako } from 'app/shared/services/pako.service';

import {  MDBBootstrapModules } from 'ng-mdb-pro';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PdfService } from "./services/pdf.service";
import { PdfGenerateBtnComponent } from "./pdf-generate-btn/pdf-generate-btn.component";

// AOT compiler for production build was not recognizing third party library injection using "useValue"
// when a string literal was specified.  This blog post showed that using a factory fixed the problem
// https://stackoverflow.com/questions/43445947/window-is-undefined-when-used-as-usevalue-provider-with-angular-4-aot
export function windowFactory() {
  return window;
}
export const windowToken = new InjectionToken<Window>('Window');
export const windowProvider = { provide: windowToken, useValue: window };
import {HostSiteService} from"./services/host-site.service";
import { SsoCrossDomainMessenger } from './services/sso-cross-domain-messenger';
import { BuyItemButtonComponent } from './buy-item-button/buy-item-button.component';
import { OrderService } from './services/order.service';
import { ShoppingService } from './services/shopping.service';
import { BillingDetailsComponent } from './billing-details/billing-details.component';
import { BillingCardComponent } from './billing-card/billing-card.component';
import { BillingService } from './services/billing.service';
import { AssignmentHydratorService } from './services/assignment-hydrator.service';
import { AssignmentService } from './services/assignment.service';
import { CopyClipboardComponent } from './copy-clipboard/copy-clipboard.component';
import { CopyClipboardService } from './services/copy-clipboard.service';

import { AssessmentGroupListComponent } from './assessment-group-list/assessment-group-list.component';
import { AssessmentGroupService } from './services/assessment-group.service';
import { SubscriptionHydratorService } from './services/subscription-hydrator.service';
import { MetricsService } from './services/metrics.service';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,RouterModule
    ,MDBBootstrapModules
  ],
  declarations: [AssessmentPickerComponent, SpinIconComponent, IfFeatureEnabled, ConditionEditComponent
      ,SearchInputComponent, BackButtonComponent, UserSelectorComponent, RoleSelectorComponent
      , UsernameCheckerComponent, PdfGenerateBtnComponent, 
      BuyItemButtonComponent
      ,BillingDetailsComponent,
      BillingCardComponent,
      CopyClipboardComponent,
      AssessmentGroupListComponent
    ],
    
  // TODO: stephen just found out according to this documentation that all of my lazy loaded modules
  // create distinct copies of these services I'm sharing...  So I need to figure out what to do with
  // all the providers I want to be singletons...
  // https://angular.io/guide/ngmodule#!#shared-module
  providers: [],
  exports: [
    AssessmentPickerComponent, SpinIconComponent, IfFeatureEnabled, ConditionEditComponent
    , SearchInputComponent, BackButtonComponent, UserSelectorComponent
    , RoleSelectorComponent, UsernameCheckerComponent, BuyItemButtonComponent
    , BillingDetailsComponent, BillingCardComponent, AssessmentGroupListComponent
    ,CommonModule
    ,FormsModule
    // mdb components
    , MDBBootstrapModules
    ,PdfGenerateBtnComponent
    ,CopyClipboardComponent
  ]
})
export class SharedModule { 

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [windowProvider,
        Authenticator, DacConfig, PaginatedResultsLoaderFactory, AssessmentService, AssessmentResultHydrator
        , AssessmentHydrator,HTTPService, UniqueIdService, ClientService, StripePaymentProcessor
        , AssessmentTokenService, AssessmentCompressorService, QuestionFactoryService, AssessmentGraderService
        , QuestionAnswerPopulator, UserService, CompanyService, AlertService, Pako, PdfService, HostSiteService
        , SsoCrossDomainMessenger, ShoppingService, OrderService, BillingService,AssignmentHydratorService
        , AssignmentService, CopyClipboardService, AssessmentGroupService, SubscriptionHydratorService, MetricsService ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts